import { Record } from 'immutable';

const LookupAddressRecord = Record({
  line1: null,
  line2: null,
  city: null,
  state: null,
  postalCode: null
});

export class LookupAddress extends LookupAddressRecord {
  line1: string;
  line2: string;
  city: string;
  state: string;
  postalCode: number;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/lookup-address.ts